import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlightSearchComponent } from './flight-search.component';
import { DateRangeModule } from 'src/app/libs/ui/components/date-range/date-range.module';
import { AutoCompleteFormFieldModule } from 'src/app/libs/ui/components/auto-complete-form-field/auto-complete-form-field.module';
import { AdultsChildrenAgeModule } from '../adults-children-age/adults-children-age.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { ButtonModule } from 'src/app/libs/ui/components/button/button.module';
import { PackageTypeDropdownModule } from 'src/app/libs/ui/components/package-type-dropdown/package-type-dropdown.module';

@NgModule({
    declarations: [
        FlightSearchComponent
    ],
    imports: [
        CommonModule,
        DateRangeModule,
        AutoCompleteFormFieldModule,
    AdultsChildrenAgeModule,
    ReactiveFormsModule,
    FormsModule,
    MatSelectModule,ButtonModule,
    PackageTypeDropdownModule
    ],exports: [
        FlightSearchComponent,
      ],
})
export class FlightSearchModule { }
